<template>
    <div class="container-fluid bannerPcWrapper bannerPc bannerPc01" ref="bannerPc">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MainTableBanner",
        created() {
            let vm = this
            this.$nextTick(function () {
                $(vm.$refs.bannerPc).find("#tab1").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc02 bannerPc03 bannerPc04 bannerPc05 bannerPc06 bannerPc07").addClass("bannerPc01");
                });
                $(vm.$refs.bannerPc).find("#tab2").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc01 bannerPc03 bannerPc04 bannerPc05 bannerPc06 bannerPc07").addClass("bannerPc02");
                });
                $(vm.$refs.bannerPc).find("#tab3").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc01 bannerPc02 bannerPc04 bannerPc05 bannerPc06 bannerPc07").addClass("bannerPc03");
                });
                $(vm.$refs.bannerPc).find("#tab4").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc01 bannerPc02 bannerPc03 bannerPc05 bannerPc06 bannerPc07").addClass("bannerPc04");
                });
                $(vm.$refs.bannerPc).find("#tab5").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc01 bannerPc02 bannerPc03 bannerPc04 bannerPc06 bannerPc07").addClass("bannerPc05");
                });
                $(vm.$refs.bannerPc).find("#tab6").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc01 bannerPc02 bannerPc03 bannerPc04 bannerPc06 bannerPc07").addClass("bannerPc06");
                });
                $(vm.$refs.bannerPc).find("#tab7").click(function(){
                    $(vm.$refs.bannerPc).removeClass("bannerPc01 bannerPc02 bannerPc03 bannerPc04 bannerPc05 bannerPc06").addClass("bannerPc07");
                });
            })
        },
        mounted() {
            let vm = this

        }
    }
</script>

<style scoped>

</style>